import React, { useState } from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { FadeUp } from '../ui/FadeUp';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-border-custom" data-id="element-42">
      <button className="w-full bg-transparent border-none py-[18px] font-sans text-[14px] text-charcoal text-left cursor-pointer flex justify-between items-center gap-3 font-medium" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-43">
        {question}
        <span className={`text-[18px] text-plum transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-45' : ''}`} data-id="element-44">
          +
        </span>
      </button>

      <div className={`overflow-hidden transition-all duration-400 ease-in-out ${isOpen ? 'max-h-[300px] pb-[18px]' : 'max-h-0'}`} data-id="element-45">
        <p className="text-[13px] text-muted leading-[1.7]" data-id="element-46">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito experiencia previa en meditación?',
    answer: 'No. El sistema está diseñado para ser aplicado por cualquier persona, independientemente de su experiencia previa. Las 3 fases son claras, guiadas y están pensadas para el día a día.'
  }, {
    question: '¿Cuánto tiempo me va a llevar?',
    answer: 'El sistema completo funciona en menos de 15 minutos. La Fase 01 sola puede hacerse en 5 minutos. Está pensado para integrarse en tu rutina real, no para agregar otra tarea más.'
  }, {
    question: '¿Es compatible si ya hago terapia?',
    answer: 'Sí, totalmente. ProMind Energy no reemplaza ningún proceso terapéutico. Es un sistema de higiene energética cotidiana que complementa cualquier proceso de desarrollo personal que ya estés haciendo.'
  }, {
    question: '¿Cómo accedo al material?',
    answer: 'Inmediatamente después de tu compra recibís acceso de por vida al sistema completo. Todo en un solo lugar, desde cualquier dispositivo.'
  }];
  return <SectionWrapper bgColor="sand" id="faq" data-id="element-47">
      <FadeUp data-id="element-48">
        <h2 className="text-[clamp(28px,8vw,40px)] text-center mb-8" data-id="element-49">
          Preguntas
          <br data-id="element-50" />
          <em className="font-serif italic text-plum" data-id="element-51">frecuentes</em>
        </h2>
      </FadeUp>

      <FadeUp delay={0.1} data-id="element-52">
        <div data-id="element-53">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-54" />)}
        </div>
      </FadeUp>
    </SectionWrapper>;
}